import { BaseModel } from './base.model';
import { AppConstants } from '../constants/app.constants';

export class PageDatatableModel extends BaseModel {
  //The number of elements in the page
    size: number = Number(localStorage.getItem('pageSize'));
    //The total number of elements
    totalCount: number = 0;
    //The total number of pages
    totalPages: number = 0;
    //The current page number
    pageNumber: number = 1;
    // The current page number loaded
    currentPageClient: number = 0;
}
